// extracted by mini-css-extract-plugin
module.exports = {"disabled":"CustomCardsColumns_disabled__X2SlB"};